import { createContext } from "react";
import type { DrawingStore } from "../DrawingProvider.types";

const DrawingStoreContext = createContext<DrawingStore | undefined>(undefined);
DrawingStoreContext.displayName = "DrawingStoreContext";

export default DrawingStoreContext;
